<template>
  <section>
    <el-form
      ref="send-form"
      :rules="rules"
      :model="sendFormData">
      <div class="plan-header">
        <div class="info flex">
          <h3>{{isEmail}}</h3>
        </div>
      </div>
      <div class="form-item">
        <span>Customer</span>
        <div>
          <span v-if="form.cust_typ == 1||!isCompany">{{ form.customer? form.customer.isrd_nm: '' }} {{ ` - ${form.mobile_no}` }}</span>
          <span v-else>{{ form.contact_email||form.email }}</span>
        </div>
      </div>
      <div
        v-if="emailListTitle"
        class="form-item">
        <span>Email list title</span>
        <div>
          <span>{{emailListTitle}}</span>
        </div>
      </div>
      <div
        v-if="emailTitle"
        class="form-item">
        <span>Title</span>
        <div>
          <span>{{emailTitle}}</span>
        </div>
      </div>
      <div class="form-item">
        <span>Content</span>
        <el-form-item prop="content">
          <v-input
            v-model="sendFormData.content"
            type="textarea"
            :rows="4" />
        </el-form-item>
      </div>
    </el-form>
    <div class="flex-sb-center">
      <div>
        <v-button @click="onCancel">Cancel</v-button>
      </div>
      <div>
        <v-button @click="onSkip">Skip</v-button>
        <v-button
          type="success"
          @click="onSend">Send</v-button>
      </div>
    </div>
  </section>
</template>
<script>
import MixinRules from '@/mixins/rules'
import {
  sendOrderIssueIssuingNotice } from '@/api/order'
export default {
  name: 'SendEmailSmsDialog',
  mixins: [MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
    initContent: {
      type: String,
      default: ''
    },
    emailListTitle: {
      type: String,
      default: ''
    },
    emailTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialog: false,
      sendFormData: {
        content: ''
      }
    }
  },
  computed:{
    isEmail(){
      let {customer={},identity} = this.form||{}
      console.log('customer--',customer)
      return identity==2||customer.identity==2?'Send Email':'Send SMS'
    },
    isCompany(){
      let {customer={},identity} = this.form||{}
      return identity==2||customer.identity==2
    }
  },
  watch: {
    initContent: {
      immediate: true,
      handler(val, old) {
        if(val != old && !this.sendFormData.content) {
          this.sendFormData.content = val
        }
      }
    }
  },
  methods: {
    changeDialog() {
      this.dialog = !this.dialog
      console.log('this.dialog',this.dialog)
    },
    onCancel() {
      this.$emit('cancel')
    },
    onSend() {
      this.$refs['send-form'].validate((valid, rules) => {
        if(valid) {
          //   this.network().orderIssueIssuing('send')
          this.$emit('send', this.sendFormData)
        }
        else {
          console.log(rules)
        }
      })
    },
    onSkip() {
      //   this.network().orderIssueIssuing()
      this.$emit('skip')
    },
    network() {
      return {
        sendOrderIssueIssuingNotice: async () => {
          const { data } = await sendOrderIssueIssuingNotice({
            order_id: this.orderId,
            content: this.sendFormData.content
          })
          this.dialog = false
          this.$emit('success')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
      padding: 15px;
  .plan-header {
    background: #F6F8FA;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    border: 1px solid #E1E4E8;
    margin: -15px -15px 15px;
    padding: 15px 15px 0px;
  }
      h3 {
        padding-bottom: 10px;
      }
      p {
        padding-bottom: 10px;
      }
      .dialog-footer {
        margin: 15px -15px -15px;
        padding: 15px;
        text-align: right;
        background: #F9FAFB;
      }
      .form-item {
          & > span {
              font-weight: bold;
              font-size: 16px;
          }
      }
    }
</style>
